import {Icon} from 'semantic-ui-react';



export const servicesData = [
    {
        "institute": "K-12 Math & English Language Arts Tutoring",
        "services": [
            {
                "service": "Adhering to Common Core Standards in New York State",
                "subBullet": null
            },
            {
                "service": "Cooperative Admissions Examination Program (COOP)",
                "subBullet": null
            },
            {
                "service": "Specialized High School Admissions Test (SHSAT)",
                "subBullet": null
            },
            {
                "service": "Secondary School Admission Test (SSAT)",
                "subBullet": null
            },
            {
                "service": "High School Placement Test (HSPT)",
                "subBullet": "Catholic High School Tests For: Regis, Xavier, Loyola, Fordham and others"
            },
            {
                "service": "Independent School Entrance Exam (ISEE)",
                "subBullet": null
            },
            {
                "service": "Test for Admission into Catholic High Schools (TACHS)",
                "subBullet": null
            },
            {
                "service": "New York State Regents Preparation",
                "subBullet": null
            }
        ]
    },
    {
        "institute": "High School Nationwide Exam Prep",
        "services": [
            {
                "service": "PSAT",
                "subBullet": null
            },
            {
                "service": "SAT",
                "subBullet": null
            },
            {
                "service": "SAT II",
                "subBullet": "SAT Subject Tests: English and Mathematics"
            },
            {
                "service": "ACT",
                "subBullet": null
            },
            {
                "service": "Advanced Placement (AP)",
                "subBullet": null
            }
        ]
    },
    {
        "institute": "Undergraduate College Prep",
        "services": [
            {
                "service": "College Search Process",
                "subBullet": "Application Review and Completion for Admissions and Enrollment"
            },
            {
                "service": "College Essays",
                "subBullet": "Guidance and Revision"
            },
            {
                "service": "College Tours",
                "subBullet": "In-person and Online"
            },
            {
                "service": "Mock Interviews",
                "subBullet": "Admissions"
            }
        ]
    },
    {
        "institute": "Graduate School Exam Prep",
        "services": [
            {
                "service": "GRE",
                "subBullet": null
            },
            {
                "service": "GMAT",
                "subBullet": null
            }
        ]
    }
]